//PACKS
import React, { useEffect, useState } from "react";

//COMPONENTS
import MissionModal from "./MissionModal";

//STYLES
import "../styles/mission.scss";

export default function MissionCard(props) {
  //STATES
  const [mission, setMission] = useState({});
  const [toggle, setToggle] = useState(false);

  //ON PROP CHANGE
  useEffect(() => {
    setMission(props.mission);
  }, [props]);

  return (
    <div
      className="mission"
      onClick={() => {
        setToggle(!toggle);
      }}
    >
      <MissionModal description={mission.description} toggle={toggle} />
      <div className="missionIconContainer">
        <i className={mission.icon + " fa-2x"} />
      </div>
      <div className="missionTitleContainer">{mission.title}</div>
    </div>
  );
}
